const BYTES_PER_KB = 1024;

const BYTES_PER_MB = BYTES_PER_KB ** 2;

export const IMAGE_SIZE_LIMIT_MB = 5;

export const IMAGE_SIZE_LIMIT_BYTES = IMAGE_SIZE_LIMIT_MB * BYTES_PER_MB;
